
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Ertigahireforcorporateinpune() {



    const cardData =
    {
        keyword: 'Ertiga Hire for Corporate in Pune  ',
        heading: 'etravo : Ertiga Hire for Corporate in Pune',



"headingDescription": "eTravo offers reliable Ertiga Hire for Corporate Travel in Pune, designed for companies, IT firms, and business professionals who need comfortable and cost-effective group transportation. The Maruti Ertiga is ideal for employee pickup and drop, airport transfers, client meetings, and short outstation corporate trips. With spacious seating for up to 6–7 passengers, GPS-enabled tracking, and experienced chauffeurs, eTravo ensures safe, punctual, and smooth corporate mobility across Pune.",

"top": "Top Use Cases for Ertiga Corporate Hire in Pune with eTravo",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Ideal for employee shuttle services and shift-based corporate transport for IT companies and MNCs operating in Pune’s largest tech hub."
  },
  {
    "title": "Kharadi IT Park",
    "description": "Widely used for daily office pickup and drop services for employees working in EON IT Park and surrounding corporate offices."
  },
  {
    "title": "Magarpatta City",
    "description": "A structured IT township where Ertiga vehicles are commonly used for group employee transport and corporate commuting."
  },
  {
    "title": "Hadapsar",
    "description": "A key industrial and IT zone where Ertiga is preferred for cost-effective and comfortable employee transportation."
  },
  {
    "title": "Baner-Balewadi",
    "description": "A growing corporate hub where startups and offices use Ertiga for executive travel and small team transport."
  },
  {
    "title": "Viman Nagar",
    "description": "Commonly used for airport transfers, client pickups, and corporate guest transportation due to its proximity to Pune Airport."
  },
  {
    "title": "Wakad",
    "description": "A major residential area for IT employees where Ertiga is widely used for daily office commute to Hinjewadi."
  },
  {
    "title": "Koregaon Park",
    "description": "Used for premium corporate visits, meetings, and small group executive travel in a business-friendly locality."
  },
  {
    "title": "Shivajinagar",
    "description": "Central business district where Ertiga is used for official visits, government meetings, and corporate travel needs."
  },
  {
    "title": "Pimpri-Chinchwad",
    "description": "Industrial zone where Ertiga is used for workforce movement, factory visits, and corporate logistics support."
  }
],


"services": [
{
"name": "Ertiga Hire Pune Corporate",
"description": "eTravo offers Ertiga hire in Pune for corporate use, providing comfortable and spacious travel for employees and executives. Our service ensures reliable daily commuting, professional chauffeurs, and smooth transportation for business needs."
},
{
"name": "Ertiga Cab Pune",
"description": "Our Ertiga cab services in Pune are ideal for both corporate and personal travel. eTravo ensures clean vehicles, punctual service, and comfortable rides for city and outstation journeys."
},
{
"name": "Maruti Ertiga Rental Pune",
"description": "eTravo provides Maruti Ertiga rental in Pune for customers seeking spacious and economical travel. Perfect for group travel and corporate use, our vehicles ensure comfort and reliability."
},
{
"name": "Ertiga Taxi Pune",
"description": "eTravo’s Ertiga taxi services in Pune offer a smooth and comfortable travel experience. Our taxis are ideal for daily commuting, office travel, and family trips with professional drivers."
},
{
"name": "Corporate Ertiga Hire Pune",
"description": "Choose eTravo’s corporate Ertiga hire in Pune for efficient employee transport and business travel. Our service ensures timely pickups, comfortable seating, and reliable performance for daily operations."
},
{
"name": "Ertiga Car Rental Pune",
"description": "eTravo offers Ertiga car rental services in Pune with flexible booking options. Our vehicles are well-maintained and perfect for both short and long journeys."
},
{
"name": "Ertiga for Office Use Pune",
"description": "eTravo provides Ertiga vehicles for office use in Pune, ensuring comfortable and reliable transportation for employees. Our service supports daily commuting and business travel requirements."
},
{
"name": "Ertiga Cab Booking Pune",
"description": "Book an Ertiga cab in Pune with eTravo for a hassle-free travel experience. Our easy booking process and dependable service ensure smooth and timely journeys."
},
{
"name": "Ertiga Corporate Travel Pune",
"description": "eTravo offers Ertiga corporate travel services in Pune designed for business trips and employee transport. Our service ensures comfort, punctuality, and professional travel experiences."
},
{
"name": "Ertiga Hire Service Pune",
"description": "Our Ertiga hire services in Pune provide flexible and reliable transportation for various needs. eTravo ensures quality vehicles and professional drivers for a smooth travel experience."
},
{
"name": "Ertiga Company Cab Pune",
"description": "eTravo offers Ertiga company cab services in Pune tailored for employee commuting and business travel. Our service ensures comfort, safety, and efficient transportation."
},
{
"name": "Ertiga Vehicle Hire Pune",
"description": "Choose eTravo’s Ertiga vehicle hire in Pune for spacious and dependable travel. Our vehicles are suitable for corporate use, group travel, and daily commuting."
},
{
"name": "Ertiga Taxi Booking Pune",
"description": "eTravo provides easy Ertiga taxi booking in Pune with reliable service and comfortable vehicles. Our taxis ensure smooth and timely travel for all your needs."
},
{
"name": "Ertiga Fleet Pune",
"description": "eTravo offers Ertiga fleet services in Pune for businesses requiring multiple vehicles. Our fleet ensures consistent quality, proper maintenance, and reliable service for corporate transport."
},
{
"name": "Ertiga Staff Transport Pune",
"description": "eTravo provides Ertiga staff transport services in Pune for safe and efficient employee commuting. Our service ensures punctual pickups, comfortable rides, and smooth daily travel."
}
],
"tableData": [
["Ertiga Hire Pune Corporate", "Ertiga Cab Pune"],
["Maruti Ertiga Rental Pune", "Ertiga Taxi Pune"],
["Corporate Ertiga Hire Pune", "Ertiga Car Rental Pune"],
["Ertiga for Office Use Pune", "Ertiga Cab Booking Pune"],
["Ertiga Corporate Travel Pune", "Ertiga Hire Service Pune"],
["Ertiga Company Cab Pune", "Ertiga Vehicle Hire Pune"],
["Ertiga Taxi Booking Pune", "Ertiga Fleet Pune"],
["Ertiga Staff Transport Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Best Ertiga Hire for Corporate in Pune",
      "WhyChoosedescription": "eTravo offers reliable Ertiga hire for corporate in Pune, providing a perfect balance of comfort, affordability, and efficiency for employee transportation and business travel."
    },
    {
      "WhyChooseheading": "Spacious and Comfortable 6+1 Seater Vehicle",
      "WhyChoosedescription": "Maruti Suzuki Ertiga is ideal for corporate travel with ample seating and luggage space, making it suitable for team travel, airport transfers, and office commutes."
    },
    {
      "WhyChooseheading": "Cost-Effective Corporate Travel Solution",
      "WhyChoosedescription": "Ertiga rental is an economical option compared to larger SUVs, helping companies manage transportation costs while maintaining comfort and reliability."
    },
    {
      "WhyChooseheading": "Perfect for Daily Office and Business Travel",
      "WhyChoosedescription": "Ertiga cabs are widely used for daily employee pickup and drop, client meetings, and local corporate travel across Pune."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs for Corporate Use",
      "WhyChoosedescription": "Our trained drivers ensure safe, punctual, and professional service, maintaining corporate etiquette throughout the journey."
    },
    {
      "WhyChooseheading": "Flexible Rental Plans for Businesses",
      "WhyChoosedescription": "eTravo offers hourly, daily, monthly, and long-term Ertiga rental plans tailored to corporate travel needs and schedules."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "All Ertiga vehicles are regularly serviced and cleaned to ensure safety, hygiene, and a comfortable travel experience for employees."
    },
    {
      "WhyChooseheading": "24/7 Corporate Booking and Support",
      "WhyChoosedescription": "Our support team is available round the clock to manage bookings, schedule changes, and urgent travel requirements."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is Ertiga hire for corporate in Pune?',
            answer: 'Ertiga hire for corporate in Pune is a cab service that provides Maruti Ertiga vehicles for employee transport, business meetings, and corporate travel needs.',
        },
        {
            question: 'Why is Ertiga suitable for corporate travel?',
            answer: 'Ertiga offers spacious seating, comfort, and fuel efficiency, making it an ideal choice for small teams and daily corporate commuting.',
        },
        {
            question: 'Can I book Ertiga for daily office pickup and drop?',
            answer: 'Yes, Ertiga is commonly used for daily employee transportation with fixed routes and schedules.',
        },
        {
            question: 'Is Ertiga available for airport transfers in Pune?',
            answer: 'Yes, Ertiga cabs are widely used for airport pickup and drop services for corporate employees and clients.',
        },
        {
            question: 'Do Ertiga rentals include a driver?',
            answer: 'Yes, all Ertiga corporate rentals come with professional chauffeur-driven service.',
        },
        {
            question: 'Can I book Ertiga for outstation corporate travel?',
            answer: 'Yes, Ertiga is suitable for both local and outstation corporate trips including one-way and round-trip bookings.',
        },
        {
            question: 'Are monthly Ertiga rental plans available?',
            answer: 'Yes, eTravo offers monthly and long-term Ertiga rental plans for corporate clients.',
        },
        {
            question: 'Is Ertiga rental cost-effective for companies?',
            answer: 'Yes, Ertiga provides a budget-friendly option for corporate travel without compromising comfort.',
        },
        {
            question: 'Are vehicles sanitized and well-maintained?',
            answer: 'Yes, all vehicles are regularly serviced and cleaned to ensure safety and hygiene.',
        },
        {
            question: 'How can I book Ertiga hire for corporate in Pune?',
            answer: 'You can book online or contact the support team for quick and customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Prakash Jadhav',
        designation: 'Admin Manager, IT Company, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo’s Ertiga hire for our corporate travel in Pune. It is comfortable, economical, and perfect for our team’s daily commute.”',
    },
    {
        name: 'Ms. Kavita Shah',
        designation: 'HR Executive, Corporate Firm, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“Ertiga rentals from eTravo are ideal for employee transport. The service is punctual, and the vehicles are always clean and well-maintained.”',
    },
];









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga Hire for Corporate in Pune",
  "image": "https://www.etravo.in/images/keyword/ertiga-hire-pune.jpg",
  "description": "Affordable and comfortable Ertiga hire for corporate use in Pune by eTravo. Ideal for employee transport, office travel, staff pickup and drop, and business trips with spacious and reliable vehicles.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/ertiga-hire-for-corporate-in-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>Ertiga Hire for Corporate in Pune | Spacious Office & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire Ertiga for corporate use in Pune with eTravo for employee transport, office travel, staff pickup and drop, and business trips. Comfortable and reliable cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/135.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ertigahireforcorporateinpune;